import { render, staticRenderFns } from "./IdeaCoachDialog.vue?vue&type=template&id=44987bb0&scoped=true&"
import script from "./IdeaCoachDialog.vue?vue&type=script&lang=js&"
export * from "./IdeaCoachDialog.vue?vue&type=script&lang=js&"
import style0 from "./IdeaCoachDialog.vue?vue&type=style&index=0&id=44987bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44987bb0",
  null
  
)

export default component.exports